import styled from "styled-components";
import type { ReactNode } from "react";

/**
 * [共通パーツ]リスト
 */

type ListProps = {
  children: ReactNode;
};

const StyledList = styled.ul<ListProps>`
  display: flex;
  flex-direction: column;
`;

export function List(props: ListProps) {
  return <StyledList>{props.children}</StyledList>;
}

type ListItemProps = {
  children: ReactNode;
};

const StyledListItem = styled.li<ListItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 58px;
  border-bottom: 1px solid ${(props) => props.theme.colors.primaryBorder};
  > * {
    min-width: 180px;
  }
`;

export function ListItem(props: ListItemProps) {
  return <StyledListItem>{props.children}</StyledListItem>;
}
